import React from 'react';
import Img from '../../common/Img';
import ButtonsScroller from '../../common/ButtonsScroller';
import Bet from '../../common/Bet';
import { classIf } from '../../data/utils';
import LiveTrackerToggle from '../../common/live-tracker/LiveTrackerToggle';
import RenderOnScroll from '../../common/RenderOnScroll';
import BettingClosedMessage from '../../common/BettingClosedMessage';
import { getScores } from '../scores/scores';
import StreamingToggle from '../../common/streaming/StreamingToggle';
import FavoriteMarketsProvider from '../../common/favorite-markets/FavoriteMarkets';

export default function EventContent(props) {
    const data = props.data;
    const [header, scoresTeam1, scoresTeam2] = getScores(data.score, 'c_18_1_4_1', 'c_18_2_1_3_1');

    return (
        <FavoriteMarketsProvider>
            <div className="c_17">
                <div className="c_17_1">
                    <div className="c_18" data-live>
                        <div className="c_18_1">
                            <span className="c_18_1_2">{data.categoryDesc} | {data.tournamentDesc}</span>
                            <div className="c_18_1_4">{header}</div>
                            <div className="c_18_1_3">
                                <LiveTrackerToggle data={data} />
                                <StreamingToggle className="c_18_1_3_1" match={data} />
                                <Img className="c_18_1_3_1" src="icon_close.svg" height="32px" width="32px" onClick={() => window.history.back()} />
                            </div>
                        </div>
                        <div className="c_18_2">
                            <div className="c_18_2_1">
                                <div className="c_18_2_1_1">{data.score?.periodo}</div>
                                <div className="c_18_2_1_2">{data.team1}</div>
                                <div className="c_18_2_1_3">{scoresTeam1}</div>
                                <div className="c_18_2_1_4"></div>
                            </div>
                            <div className="c_18_2_1">
                                <div className="c_18_2_1_1">{data.score?.currentMinute}</div>
                                <div className="c_18_2_1_2">{data.team2}</div>
                                <div className="c_18_2_1_3">{scoresTeam2}</div>
                                <div className="c_18_2_1_4"></div>
                            </div>
                        </div>
                    </div>
                    <ButtonsScroller>
                        {data.gruppiScommessa.map((a, i) =>
                            <React.Fragment key={a.idAggregata}>
                                {/* {i === 1 &&
                                    <div className="c_20_2_1">{getLabel('betbuilder.title')}</div>
                                } */}
                                <div className={"c_20_2_1" + classIf(props.aggId === a.idAggregata, 'active')} onClick={() => props.changeAgg(a.idAggregata)}>{a.descrizione}</div>
                            </React.Fragment>
                        )}
                    </ButtonsScroller>
                </div>
                {data.giocabilita === false ?
                    <BettingClosedMessage />
                    :
                    <div className="c_17_2" key={props.macroId}>
                        <RenderOnScroll start={10} increment={5}>
                            {data.bets.map(b => {
                                if (!b.hasOdds) {
                                    return null;
                                }
                                return <Bet key={b.uniqueId} data={b} />;
                            })}
                        </RenderOnScroll>
                    </div>
                }
            </div>
        </FavoriteMarketsProvider>
    );
}
